export default __webpack_public_path__ + "static/media/close.d948a720.svg";